"use client";

import { useEffect, useRef } from "react";
import posthog from "posthog-js";
import {
  captureAndStoreAttribution,
  getAttributionForPostHog,
  hasAttributionData,
} from "@/lib/attribution";

/**
 * Hook to capture attribution data on page load
 * Should be used in the app's providers to capture attribution on every page
 */
export function useAttribution() {
  const hasInitialized = useRef(false);

  useEffect(() => {
    // Only run once per session
    if (hasInitialized.current) return;
    hasInitialized.current = true;

    // Capture and store attribution
    const attribution = captureAndStoreAttribution();

    // Send to PostHog if we have meaningful attribution data
    if (attribution && hasAttributionData(attribution.firstTouch)) {
      const posthogProps = getAttributionForPostHog();

      // Set user properties for attribution
      if (posthog.__loaded) {
        posthog.register(posthogProps);

        // Capture attribution event (only on first visit)
        if (
          attribution.firstTouch.capturedAt === attribution.lastTouch.capturedAt
        ) {
          posthog.capture("attribution_captured", {
            source: attribution.firstTouch.source,
            medium: attribution.firstTouch.medium,
            campaign: attribution.firstTouch.campaign,
            landing_page: attribution.firstTouch.landingPage,
          });
        }
      }
    }
  }, []);
}
